import React from 'react';
import { Route } from 'react-router';
import Library, {
  Item,
  Category,
  Discount,
  Promo,
  Gratuity,
  Modifier,
  Tax,
  SalesType,
  Brand,
} from 'pages/Library';
import createCustomRoute from 'hocs/createCustomRoute';

const OutletLibraryRoutes = createCustomRoute('OutletLibraryRoutes', props => (
  <Route {...props} component={Library}>
    <Route path="list" component={Item} />
    <Route path="categories" component={Category} />
    <Route path="discounts" component={Discount} />
    <Route path="promo" component={Promo} />
    <Route path="gratuity" component={Gratuity} />
    <Route path="modifier" component={Modifier} />
    <Route path="taxes" component={Tax} />
    <Route path="sales_type" component={SalesType} />
    <Route path="brands" component={Brand} />
  </Route>
));

export default OutletLibraryRoutes;
